var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", {
    staticClass: "navbar"
  }, [_c("hamburger", {
    staticClass: "hamburger-container",
    attrs: {
      id: "hamburger-container",
      "is-active": _vm.sidebar.opened
    },
    on: {
      toggleClick: _vm.toggleSideBar
    }
  }), _c("breadcrumb", {
    staticClass: "breadcrumb-container",
    attrs: {
      id: "breadcrumb-container"
    }
  }), _c("div", {
    staticClass: "center-content"
  }, [_c("el-tag", {
    attrs: {
      effect: "dark"
    }
  }, [_vm._v(" App Version: " + _vm._s(_vm.adminVersion) + " ")])], 1), _c("div", {
    staticClass: "right-menu"
  }, [_vm.device !== "mobile" ? [_c("div", {
    staticClass: "right-menu-item hover-effect",
    on: {
      click: _vm.toggleFullscreen
    }
  }, [_c("i", {
    class: _vm.isFullscreen ? "el-icon-aim" : "el-icon-full-screen",
    attrs: {
      title: _vm.isFullscreen ? "Exit Fullscreen" : "Enter Fullscreen"
    }
  })]), _c("span", {
    staticClass: "right-menu-item"
  }, [_c("el-tag", {
    attrs: {
      effect: "dark",
      type: "success"
    }
  }, [_vm._v("Welcome " + _vm._s(_vm.loggedInUser))])], 1)] : _vm._e(), _c("el-dropdown", {
    staticClass: "avatar-container right-menu-item hover-effect",
    attrs: {
      trigger: "click"
    }
  }, [_c("div", {
    staticClass: "avatar-wrapper"
  }, [_c("img", {
    staticClass: "user-avatar",
    attrs: {
      src: "https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png"
    }
  }), _c("i", {
    staticClass: "el-icon-caret-bottom"
  })]), _c("el-dropdown-menu", {
    attrs: {
      slot: "dropdown"
    },
    slot: "dropdown"
  }, [_c("router-link", {
    attrs: {
      to: "/profile/"
    }
  }, [_c("el-dropdown-item", [_vm._v(_vm._s(_vm.$t("navbar.profile")))])], 1), _c("router-link", {
    attrs: {
      to: "/"
    }
  }, [_c("el-dropdown-item", [_vm._v(_vm._s(_vm.$t("navbar.dashboard")))])], 1), _c("el-dropdown-item", {
    attrs: {
      divided: ""
    }
  }, [_c("span", {
    staticStyle: {
      display: "block"
    },
    on: {
      click: _vm.logout
    }
  }, [_vm._v(_vm._s(_vm.$t("navbar.logOut")))])])], 1)], 1)], 2)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };